import { jsx as a } from "react/jsx-runtime";
import { Loader as m } from "@perxis-auto/ui-kit/lib/components/Loader";
import t from "./Loader.module.scss.js";
function i({ className: r, size: o = "large", ...e }) {
  return /* @__PURE__ */ a(m, { size: o, className: `${t.loader} ${r || ""}`, ...e });
}
export {
  i as Loader
};
